<style>
  .c-aside .list-group-item {
    cursor: pointer;
  }
</style>

<template>
  <b-tabs class="c-aside">
    <b-tab>
      <template slot="title">
        <i class='fa fa-home'></i>
      </template>
      <div class="p-3">
        <h6>{{Core.Definition.getDefinition('Établissements')}}</h6>
        <b-list-group flush>
          <b-list-group-item @click="onBranchClick(branch)" v-for="branch in Core.Session.branches" :class="{ 'active' : branch.id === Core.Session.branchId }">
            <div>{{branch.name}}</div>
            <small>{{branch.address}} {{branch.city}}</small>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-tab>
    <b-tab v-if="Core.Session.AuthUser.can('setting_ui_management_post')">
      <template slot="title">
        <i class='fa fa-eye'></i>
      </template>
      <div class="p-3">
        <h6>{{Core.Definition.getDefinition('Apparence')}}</h6>

        <Request
                ref="requestUI"
                :onRequestSuccess="requestSuccess"
                method="POST"
                root="/setting/environment-ui">
          <slot slot="body">
            <div class="aside-options">
              <div class="clearfix mt-4">
                <small><b>{{Core.Definition.getDefinition('Thème')}}</b></small>
                <b-select
                        v-model="dataTheme">
                  <option v-for="option in Core.Theme.themeOptions()" :value="option.value">{{option.label}}</option>
                </b-select>
              </div>
              <div>
                <small class="text-muted"></small>
              </div>
            </div>

            <div v-if="dataTheme === Core.Theme.themeCustom">
              <hr>
              <h6 v-b-toggle.general>{{Core.Definition.getDefinition('Général')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="general">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur primaire')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.primary.color"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.backgroundColor"></InputColor>
                  </div>
                </div>
              </b-collapse>

              <hr>
              <h6 v-b-toggle.mainMenu>{{Core.Definition.getDefinition('Menu principal')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="mainMenu">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.sidebar.backgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan sélectionné')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.sidebar.navLink.activeBackgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Titre')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.sidebar.title.color"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Texte')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.sidebar.navLink.color"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Texte sélectionné')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.sidebar.navLink.activeColor"></InputColor>
                  </div>
                </div>
              </b-collapse>

              <hr>
              <h6 v-b-toggle.headbar>{{Core.Definition.getDefinition('Menu du haut')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="headbar">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.headbar.backgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.headbar.color"></InputColor>
                  </div>
                </div>
              </b-collapse>

              <hr>
              <h6 v-b-toggle.headnav>{{Core.Definition.getDefinition('Navigation du haut')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="headnav">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.headnav.backgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur texte')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.headnav.color"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur lien')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.headnav.linkColor"></InputColor>
                  </div>
                </div>
              </b-collapse>

              <hr>
              <h6 v-b-toggle.pagination>{{Core.Definition.getDefinition('Pagination')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="pagination">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.pagination.backgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan sélectionné')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.pagination.activeBackgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.pagination.color"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur sélectionné')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.pagination.activeColor"></InputColor>
                  </div>
                </div>
              </b-collapse>

              <hr>
              <h6 v-b-toggle.card>{{Core.Definition.getDefinition('Fiche')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="card">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan entête')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.card.headerBackgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur entête')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.card.headerColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.card.backgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.card.color"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Bordure')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.card.borderColor"></InputColor>
                  </div>
                </div>
              </b-collapse>

              <hr>
              <h6 v-b-toggle.table>{{Core.Definition.getDefinition('Tableau')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="table">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan entête')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.table.headerBackgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur entête')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.table.headerColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.table.backgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.table.color"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Bordure')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.table.borderColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan pied')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.table.footerBackgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur pied')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.table.footerColor"></InputColor>
                  </div>
                </div>
              </b-collapse>

              <hr>
              <h6 v-b-toggle.footer>{{Core.Definition.getDefinition('Pied de page')}}<i class="text-muted pull-right fa fa-chevron-down"></i></h6>
              <b-collapse id="footer">
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Arrière-plan')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.footer.backgroundColor"></InputColor>
                  </div>
                </div>
                <div class="aside-options">
                  <div class="clearfix mt-3">
                    <small><b>{{Core.Definition.getDefinition('Couleur')}}</b></small>
                  </div>
                  <div>
                    <InputColor mode="sketchCompact" v-model="Core.Theme.customStyle.footer.color"></InputColor>
                  </div>
                </div>
              </b-collapse>

            </div>

            <hr>
            <div class="aside-options mb-4">
              <div class="clearfix mt-3">
                <b-button @click="onSaveClick" class="btn btn-sm btn-success">{{Core.Definition.getDefinition('Enregistrer')}}</b-button>
              </div>
            </div>
          </slot>
        </Request>

      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
  import InputColor from '../../components/InputColor'
  import InputSelect from '../../components/InputSelect'
  import Request from '../../components/Request'
  export default {
    name: 'DefaultAside',
    components: {
      InputColor,
      InputSelect,
      Request
    },
    watch: {
      'Core.Theme.customStyle': {
          handler(val) {
            Core.Theme.buildSheetFromCustom()
          },
          deep: true
      },
      dataTheme(val) {
        switch(val) {
          case Core.Theme.themePerfoplanning:
            Core.Theme.resetStyle()
            break
          case Core.Theme.themeCustom:
            Core.Theme.buildSheetFromCustom()
            break
        }
      }
    },
    data: () => {
      return {
        Core: window.Core,
        dataTheme: Core.Session.Setting.getSetting('environment.ui.theme')
      }
    },
    computed: {
    },
    methods: {
      onBranchClick(branch) {
        if (branch.id !== undefined) {
          Core.Session.branchId = branch.id
          Core.Session.setCookies()
          location.reload()
        }
      },
      onSaveClick() {
        this.$refs.requestUI.clearArgs()
        this.$refs.requestUI.addArg('theme', this.dataTheme)
        if (this.dataTheme === Core.Theme.themeCustom) {
          this.$refs.requestUI.addArg('customStyles', JSON.stringify(Core.Theme.customStyle))
        }
        this.$refs.requestUI.request()
      },
      requestSuccess(data) {

      }
    }
  }
</script>